export function packingSuggestions(
	month: number,
	days: number,
	companion?: string,
	destination?: string,
) {
	return [
		{ id: "charger", title: "충전기·일본용 110V 어댑터" },
		...(days >= 4 ? [{ id: "laundry", title: "세탁용품·여벌 옷" }] : []),
		...(month >= 6 && month <= 10
			? [{ id: "umbrella", title: "접이식 우산·젖은 물건 주머니" }]
			: []),
		...(month <= 3 || month >= 11
			? [{ id: "coat", title: "겉옷·보온용품" }]
			: [{ id: "sun", title: "자외선 차단제·모자" }]),
		...(companion === "baby"
			? [
					{ id: "baby-food", title: "아기 식사·기저귀·아기 수첩" },
					{ id: "baby-stroller", title: "유모차·아기띠" },
				]
			: []),
		...(companion === "parents"
			? [{ id: "parents-rest", title: "상비약·편한 신발·휴식 시간 확인" }]
			: []),
		...(["OKA", "ISG", "MMY", "SHI"].includes(destination ?? "")
			? [{ id: "swim", title: "물놀이 옷·방수 주머니" }]
			: []),
	];
}
